"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.body = void 0;
const validation_1 = __importDefault(require("../../../../validation"));
const bodyRules = {
    paymentMethodId: validation_1.default.rules.string().required().label('Payment Method Id'),
    stripeCustomerId: validation_1.default.rules.string().required().label('Stripe Customer Id'),
};
// eslint-disable-next-line import/prefer-default-export
exports.body = {
    rules: bodyRules,
    schema: validation_1.default.schema(bodyRules),
};
